import { TablePagination } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { TablePaginationActions } from '../table';

interface TablePaginationWrapperProps {
  data?: any;
  rowsPerPage?: number;
  page?: number;
  handleChangePage?: (event: unknown, newPage: number) => void;
  handleChangeRowsPerPage?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export default function TablePaginationWrapper({
  data,
  rowsPerPage,
  page,
  handleChangePage,
  handleChangeRowsPerPage,
}: TablePaginationWrapperProps) {
  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={[5, 20, 50, 100, 250, 500]}
      count={data?.total ?? data?.totalDocs ?? data?.meta?.total ?? 0}
      rowsPerPage={rowsPerPage ?? 20}
      page={(data?.total || data?.totalDocs || data?.meta?.total) ? (page ?? 0) : 0}
      SelectProps={{
        inputProps: {
          'aria-label': 'rows per page',
        },
        native: true,
      }}
      labelRowsPerPage={t('Rows per page')}
      onPageChange={handleChangePage ?? (() => {})}
      onRowsPerPageChange={handleChangeRowsPerPage ?? (() => {})}
      ActionsComponent={TablePaginationActions}
    />
  );
}
